import React from 'react';
import CalculationComponent from './NewControls/CalculationComponent';
import { getControlStyle } from '../../../../../Components/helper';
import { useCustomModuleState } from '../../Context/index';
import CommonAction from './CommonAction';

function CalculationControl({
  label,
  index,
  gridIndex,
  onChange,
  relation,
  duplicatingItem,
  pageIndex,
  fromForm,
  showDelete,
  handleSupplierPermission,
  supplierVisible,
  editingInput,
  deleteItem,
  setOnElement,
  onElement,
  otherConfiguration,
  isEditCalculation,
  isCalculation,
  setIsCalculation,
  setDroppedIndex,
  setIsEditCalculation,
  boldLabel,
  handleStaticGrid,
  isStatic,
}) {
  const { customModuleState } = useCustomModuleState();
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const combinedStyles = getControlStyle(otherConfiguration);
  const showEdit = customModuleState?.modalEdit ? isEditCalculation : isCalculation;

  return !showEdit ? (
    <div className="label-added">
      <label className={`fs-custom-module asterisk-req ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</label>
      <div style={combinedStyles} className="custom-source-column">
        <p className="fs-custom-module">{relation?.readOnlyFormulaString}</p>
      </div>
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
    </div>
  ) : (
    <CalculationComponent
      setIsCalculation={setIsCalculation}
      showEdit={showEdit}
      gridIndex={gridIndex}
      pageIndex={pageIndex}
      index={index}
      deleteItem={deleteItem}
      onChange={onChange}
      setIsEditCalculation={setIsEditCalculation}
      setDroppedIndex={setDroppedIndex}
    />
  );
}

export default CalculationControl;
